import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Target, Zap, ArrowRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
interface RecommendedModesProps {
  onModeClick: (modeId: string) => void;
}
export function RecommendedModes({
  onModeClick
}: RecommendedModesProps) {
  // TODO: Make this smart based on mastery data (Phase 3)
  // For now, show hardcoded recommendations
  const recommendations = [{
    id: 'fluency',
    title: 'Vloeiend Oefenen',
    reason: 'Perfect voor dagelijkse automatisering',
    icon: Zap,
    color: 'amber'
  }, {
    id: 'sprint',
    title: 'Focus Sprint',
    reason: 'Train je zwakste onderwerpen',
    icon: Target,
    color: 'indigo'
  }];
  return <div data-id="element-3810">
      <div className="flex items-center gap-3 mb-6" data-id="element-3811">
        <div className="bg-violet-100 p-2.5 rounded-xl" data-id="element-3812">
          <Sparkles className="w-6 h-6 text-violet-600 fill-violet-600" data-id="element-3813" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-black text-slate-800 tracking-tight" data-id="element-3814">
          Aanbevolen voor jou
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6" data-id="element-3815">
        {recommendations.map((rec, index) => {
        const Icon = rec.icon;
        const colorClasses = {
          amber: {
            bg: 'bg-amber-50',
            text: 'text-amber-600',
            border: 'border-amber-200',
            hover: 'hover:border-amber-300 hover:shadow-amber-100'
          },
          indigo: {
            bg: 'bg-indigo-50',
            text: 'text-indigo-600',
            border: 'border-indigo-200',
            hover: 'hover:border-indigo-300 hover:shadow-indigo-100'
          }
        }[rec.color];
        return <motion.div key={rec.id} initial={{
          opacity: 0,
          x: index === 0 ? -20 : 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + index * 0.1
        }} whileHover={{
          y: -4,
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-3816">
              <Card className={`p-6 border-2 ${colorClasses.border} ${colorClasses.hover} transition-all cursor-pointer group relative overflow-hidden`} onClick={() => onModeClick(rec.id)} data-id="element-3817">
                {/* Decorative blob */}
                <div className={`absolute -right-8 -top-8 w-32 h-32 ${colorClasses.bg} rounded-full blur-3xl opacity-50 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-3818" />

                <div className="relative z-10 flex items-center gap-4" data-id="element-3819">
                  <div className={`p-4 rounded-2xl ${colorClasses.bg} shadow-sm border ${colorClasses.border} group-hover:scale-110 transition-transform`} data-id="element-3820">
                    <Icon className={`w-8 h-8 ${colorClasses.text}`} strokeWidth={2.5} data-id="element-3821" />
                  </div>

                  <div className="flex-1" data-id="element-3822">
                    <h3 className="text-xl font-black text-slate-900 mb-1 tracking-tight group-hover:text-violet-700 transition-colors" data-id="element-3823">
                      {rec.title}
                    </h3>
                    <p className="text-sm text-slate-600 font-semibold" data-id="element-3824">
                      {rec.reason}
                    </p>
                  </div>

                  <div className="w-10 h-10 rounded-full bg-slate-50 flex items-center justify-center text-slate-300 group-hover:bg-violet-100 group-hover:text-violet-600 transition-colors" data-id="element-3825">
                    <ArrowRight className="w-5 h-5" data-id="element-3826" />
                  </div>
                </div>
              </Card>
            </motion.div>;
      })}
      </div>
    </div>;
}